<template>
	<div class="header-container">
		<div class="fixed-header border-bottom" v-if="$route.name!='首页'">
			<div class="max-width margin-auto">
				<el-row class="fixed-header-row">
					<el-col :xs="18" :sm="18">
						<el-row>
							<el-col :span="21">
								<el-autocomplete size="small" clearable prefix-icon="el-icon-search" class="inline-input"
									v-model="searchName" :fetch-suggestions="querySearch" :placeholder="$t('el.searchPlaceholder')"
									:trigger-on-focus="false" @select="handleSelect">
								</el-autocomplete>
							</el-col>
							<el-col :span="3" style="text-align: left;">
								<el-button size="small" type="primary" icon="el-icon-search"
									@click.stop="onChangeDetails()"></el-button>
							</el-col>
						</el-row>

					</el-col>
					<el-col :xs="6" :sm="6" class="home-header-row" >
						<div class="border home-header-dropdown" :class="{'mobile-header-row':$isMobile}">
							<el-dropdown size="small" @command="handleCommand">
								<i class="el-icon-s-operation"></i>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="zh">中文</el-dropdown-item>
									<el-dropdown-item command="en">English</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="fixed-header border-bottom" v-else>
			<div class="max-width margin-auto home-header-row">
				<div class="border home-header-dropdown">
					<el-dropdown size="small" @command="handleCommand">
						<i class="el-icon-s-operation"></i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="zh">中文</el-dropdown-item>
							<el-dropdown-item command="en">English</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

		</div>
		<div class="header-warp max-width margin-auto" :class="{'none':$isMobile}">
			<el-row class="header-box">
				<el-col :xs="6" :sm="4">
					<img class="logo " src="@/assets/image/logo.jpg" @click="goHome()" />
				</el-col>
				<el-col :xs="18" :sm="20">
					<menu-nav></menu-nav>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import menuNav from './menuNav.vue'
import { searchInfo } from '@/api/index'
export default {
	components: { menuNav },
	data() {
		return {
			searchName: '',
		};
	},
	mounted() {
	},
	methods: {
		async querySearch(queryString, cb) {
			if (!queryString) {
				cb([]);
				return
			}
			this.searchName = queryString.trim();
			let input = this.searchName.toLowerCase()
			if(this.$isContractAddress(input)||input=='dtt'){
        cb([{value: input}]);
				return
			}
      if(input=='dtc'){
        cb([{value: 'dtt'}]);
        return
      }
			let type = this.getSearchType()
			let obj = {
				input: input,
				type: type
			}
			let res = await searchInfo(obj)
			if (res.code == 200) {
				let arr = [];
				let value = res.results
				if (value) {
					arr.push({
						value: value
					})
				}
				cb(arr);
			}else{
				cb([])
			}

		},

		getSearchType() {
			// type类型
			// 1:地址长度42
			// 2:交易哈希长度66
			// 3:区块 纯数字
			let tokenList = ['dtt','dtc'];
			let type = null;
			if (this.searchName.length == 42) {
        if(this.$isContractAddress(this.searchName)){
          type = 4
        }else{
          type = 1
        }
      }else if (this.searchName.length == 66) {
        type = 2
      }else if (/^\d+$/.test(this.searchName)) {
        type = 3
      }else if (tokenList.includes(this.searchName.trim().toLowerCase())) {
        type = 5
      }else{
        type = -1
      }
			return type
		},
		onChangeDetails(value) {
			let id = value ? value : this.searchName
			let type = this.getSearchType()
			if (type == 1) {
				this.$router.push({
					path: `/address/${id}`,
				})
			}
			if (type == 2) {
				this.$router.push({
					path:`/tx/${id}`,
				})
			}
			if (type == 3) {
				this.$router.push({
					path:`/block/${id}`,
				})
			}
			if (type == 4) {
				this.$router.push({
					path:`/contract/${id}`,
				})
			}
			if (type == 5) {
				this.$router.push({
					path:`/token/${id}`,
				})
			}
      if(type==-1){
        this.$router.push({
					path:`/404`,
				})
      }
			this.searchName = ''
		},
		goHome() {
			this.$router.push('/')
		},
		handleSelect(item) {
			console.log(item)
			this.onChangeDetails(item.value)
		},
		handleCommand(command) {
			this.$store.commit("setLanguage", command)
		}
	},

}
</script>

<style lang="scss" scoped>
.header-container {
	background: #fff;

	.header-warp {
		padding-top: 55px;
	}
	.none{
		display: none;
	}
	.header-box {
		width: 100%;
		height: 100px;
		@extend .align-items-center;
		.logo {
			height: 90px;
			@extend .cursor;
		}
	}

	.fixed-header {
		position: fixed;
		padding: 10px 0;
		width: 100%;
		z-index: 1;
		background: #fff;
		text-align: right;
		@include responsive(768) {
			padding: 10px;
			box-sizing: border-box;
		}
		.fixed-header-row{
			width: 100%;
			padding: 0 10px;
			@extend .justify-end;
		}
	}

	.home-header-row{
		height: 100%;
		@extend .justify-end;
		@extend .align-items-center;
		span{
			padding: 5px;
			@extend .cursor;
		}
		.home-header-dropdown{
			height: 30px;
			width: 30px;
			@extend .align-items-center;
			@extend .justify-center;
		}	
	}
	.mobile-header-row{
		position: absolute;
    top: 0;
    right:10px;
	}
	::v-deep .el-autocomplete {
		width: 100%;
	}
}
</style>